import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M2.5 18h5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H3.667l8.186-8.146a.4994.4994 0 0 0 .001-.707.5.5 0 0 0-.707-.001L3 16.253V12.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v5c0 .276.224.5.5.5zm3-15h10c.827 0 1.5.673 1.5 1.5v10c0 .827-.673 1.5-1.5 1.5h-6c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h6c.276 0 .5-.224.5-.5v-10c0-.276-.224-.5-.5-.5h-10c-.276 0-.5.224-.5.5v6c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-6C4 3.673 4.673 3 5.5 3z',
  ],
  height: 20,
  width: 20,
});
